import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/constitution/')({

}).lazy(() => import('./index.lazy').then((d) => d.Route));
